import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface IdleWarningModalProps {
  open: boolean;
  remainingMs: number;
  onStaySignedIn: () => void;
}

const formatCountdown = (ms: number): string => {
  const totalSeconds = Math.max(Math.ceil(ms / 1000), 0);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

/** FR-003, FR-004: cancelable countdown warning shown before an idle sign-out. */
export function IdleWarningModal({ open, remainingMs, onStaySignedIn }: IdleWarningModalProps) {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, color: 'text.primary', pb: 1 }}>
        You'll be signed out soon
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: 'text.secondary' }}>
          You've been inactive for a while. For your security, you'll be signed out in{' '}
          {formatCountdown(remainingMs)}.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button variant="contained" onClick={onStaySignedIn}>
          Stay signed in
        </Button>
      </DialogActions>
    </Dialog>
  );
}
